export enum IMissingInfoFilters {
  any = 'any',
  driver = 'driver',
  eta = 'eta',
  truck = 'truck',
  vin = 'vin',
  trailer = 'trailer',
  documents = 'documents',
}
